/** 控制台外壳（顶栏、账号菜单）、通用排版件（console-ui、api-snippet、task-ui）与总览页。 */
const messages = {
  'nav.overview': '总览',
  'nav.playground': '试用',
  'nav.tasks': '任务',
  'nav.assets': '素材',
  'nav.keys': 'API Key',
  'nav.docs': '文档',
  'nav.home': '官网',
  'nav.aria': '控制台导航',
  'nav.openMenu': '打开菜单',
  'nav.skip': '跳到正文',
  'nav.brandAria': 'aitoken.tools 控制台总览',
  'nav.announcement': '公告：',

  'title.overview': '总览',
  'title.keys': 'API Key',
  'title.assets': '我的素材',
  'title.taskDetail': '任务详情',
  'title.tasks': '任务与调用日志',
  'title.playground': '控制台试用',
  'title.billing': '额度记录',
  'title.referrals': '推荐返佣',
  'title.reseller': '渠道后台',
  'title.settings': '账号设置',
  'title.fallback': '控制台',
  'title.document': '{title} · aitoken.tools 控制台',

  'credit.available': '可用额度',

  'user.menu': '账号菜单',
  'user.emailVerified': '邮箱已验证',
  'user.emailUnverified': '邮箱未验证',
  'user.apiDocs': 'API 文档',
  'user.home': '返回官网首页',
  'user.logout': '退出登录',
  'user.logoutError': '退出时出错',

  'ui.loading': '加载中',
  'ui.loadFailed': '加载失败',
  'ui.errorMessage': '：{message}',
  'ui.requestId': '请求 ID',
  'ui.retry': '重试',
  'ui.prevPage': '上一页',
  'ui.nextPage': '下一页',
  'ui.pagination': '分页',
  'ui.copy': '复制',

  'task.autoDuration': '自动时长',
  'task.seconds': '{n} 秒',
  'task.inputs': '{n} 个输入',
  'cost.notCharged': '未扣费',
  'cost.settled': '已结算',
  'cost.waived': '已免单',
  'cost.released': '已释放',
  'cost.reserved': '冻结中',

  'overview.description': '{site} · Seedance 视频生成',
  'overview.manageKeys': '管理 API Key',
  'overview.submit': '提交任务',
  'overview.loadFailed': '总览加载失败',

  'contact.email': '邮箱',
  'contact.wechat': '微信 {id}',

  'kpi.aria': '关键指标',
  'kpi.available': '可用额度',
  'kpi.grantedTotal': '累计发放 {amount}',
  'kpi.reserved': '冻结中',
  'kpi.inProgress': '{n} 个任务进行中',
  'kpi.week': '近 7 天结算',
  'kpi.weekTasks': '{n} 个任务计费',
  'kpi.successRate': '成功率',
  'kpi.successSub': '成功 {ok} · 失败 {failed}，全部时间',

  'comp.title': '额度构成',
  'comp.settled': '累计结算',
  'comp.reserved': '冻结中',
  'comp.available': '可用',
  'comp.empty':
    '账号还没有可用额度。额度通过线下付款开通：联系运营付款，运营核对单号后发放到账号，到账即可提交任务。',
  'comp.aria': '额度构成：累计结算 {settled}%，冻结中 {reserved}%，可用 {available}%',
  'comp.note': '提交时按上界冻结，结束后按实际用量只结算一次，差额退回可用。',

  'api.title': '调用地址',
  'api.docs': '阅读接入文档',

  'try.sampleLabel': '示意短片：晨雾中的山间小镇',
  'try.caption': '示意画面 · 程序生成',
  'try.title': '在控制台试用生成',
  'try.body':
    '写一句提示词，比如“镜头缓缓推进，晨雾中的山间小镇”，选好分辨率和时长就能提交。和 API 调用一样，是真实任务、真实计费。',
  'try.open': '打开试用',
  'try.hint': '720p · 5 秒约冻结 ¥10 以内，以页面报价为准',

  'spend.series': '消耗',
  'spend.title': '每日消耗',
  'spend.range': '时间范围',
  'spend.days': '{n} 天',
  'spend.caption': '近 {n} 天按实际用量结算，每根柱是一天',
  'spend.empty': '这段时间还没有消耗。',
  'spend.tasks': '{n} 个任务',

  'onb.title': '接入引导',
  'onb.done': '已完成',
  'onb.todo': '未完成',
  'onb.verify': '验证邮箱',
  'onb.verifyAction': '去验证',
  'onb.quota': '获取额度',
  'onb.quotaHint': '联系运营线下付款开通',
  'onb.key': '创建 API Key',
  'onb.keyAction': '创建 Key',
  'onb.asset': '上传素材',
  'onb.assetAction': '上传',
  'onb.assetHint': '文生视频可跳过',
  'onb.task': '提交首个任务',
  'onb.taskAction': '去试用',

  'recent.title': '最近任务',
  'recent.autoRefresh': '进行中的会自动刷新',
  'recent.loadFailed': '任务加载失败',
  'recent.empty': '还没有任务。用 API 提交，或先在控制台试用生成一个视频。',
  'recent.viewAll': '查看全部任务',
};

export default messages;
